/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Error_Password_MismatchInputs */

const en_login_error_password_mismatch = /** @type {(inputs: Login_Error_Password_MismatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passwords do not match`)
};

const fr_login_error_password_mismatch = /** @type {(inputs: Login_Error_Password_MismatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les mots de passe ne correspondent pas`)
};

const de_login_error_password_mismatch = /** @type {(inputs: Login_Error_Password_MismatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Passwörter stimmen nicht überein.`)
};

const it_login_error_password_mismatch = /** @type {(inputs: Login_Error_Password_MismatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le password non corrispondono`)
};

const ru_login_error_password_mismatch = /** @type {(inputs: Login_Error_Password_MismatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пароли не совпадают`)
};

const es_login_error_password_mismatch = /** @type {(inputs: Login_Error_Password_MismatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Las contraseñas no coinciden`)
};

const zh_cn2_login_error_password_mismatch = /** @type {(inputs: Login_Error_Password_MismatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`密码不匹配`)
};

const ja_login_error_password_mismatch = /** @type {(inputs: Login_Error_Password_MismatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`パスワードが一致しません`)
};

const hi_login_error_password_mismatch = /** @type {(inputs: Login_Error_Password_MismatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सांकेतिक शब्द मेल नहीं खाते`)
};

const pt_pt2_login_error_password_mismatch = /** @type {(inputs: Login_Error_Password_MismatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`As senhas não coincidem.`)
};

/**
* | output |
* | --- |
* | "Passwords do not match" |
*
* @param {Login_Error_Password_MismatchInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const login_error_password_mismatch = /** @type {((inputs?: Login_Error_Password_MismatchInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Error_Password_MismatchInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_login_error_password_mismatch(inputs)
	if (locale === "de") return de_login_error_password_mismatch(inputs)
	if (locale === "it") return it_login_error_password_mismatch(inputs)
	if (locale === "ru") return ru_login_error_password_mismatch(inputs)
	if (locale === "es") return es_login_error_password_mismatch(inputs)
	if (locale === "zh-CN") return zh_cn2_login_error_password_mismatch(inputs)
	if (locale === "ja") return ja_login_error_password_mismatch(inputs)
	if (locale === "hi") return hi_login_error_password_mismatch(inputs)
	if (locale === "pt-PT") return pt_pt2_login_error_password_mismatch(inputs)
	return en_login_error_password_mismatch(inputs)
});